import { Link, Text } from '@chakra-ui/react';

import type { CustomIconName } from '@izimi/components';
import { CustomIcon } from '@izimi/components';

type Props = {
  iconName: CustomIconName;
  title: string;
  onClick?: () => void;
  href?: string;
};

export const HeaderMobileNavigationMenuItem = ({ iconName, title, href, onClick }: Props) => (
  <Link
    display='flex'
    width='100%'
    p={4}
    gap={4}
    onClick={onClick}
    href={href}
    isExternal={Boolean(href)}>
    <CustomIcon name={iconName} />
    <Text variant='label' fontSize='1rem'>
      {title}
    </Text>
  </Link>
);
